export default __webpack_public_path__ + "static/Stay atop of your company-06e296f983877506c5540e9b2f937c17.png";